import { render, staticRenderFns } from "./EmptyNotifier.vue?vue&type=template&id=13306526&scoped=true&"
import script from "./EmptyNotifier.vue?vue&type=script&lang=ts&"
export * from "./EmptyNotifier.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyNotifier.vue?vue&type=style&index=0&id=13306526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13306526",
  null
  
)

export default component.exports